import { ref, watch } from 'vue';

export default function useFindARoomRoute(page, isAuthenticated) {
  const findARoomButtonRoute = ref(null);

  /**
   * Generates the Find a Room button route based on the listing currently being viewed.
   * Only applies to the Listings Show page.
   */
  watch(
    () => route().current('app.listings.show*'),
    (listingShowRoute) => {
      if (listingShowRoute && !isAuthenticated) {
        const { location } = page.props?.listing || {};
        findARoomButtonRoute.value = route('app.search.units', {
          city: location?.city?.long_name,
          province: location?.province?.short_name,
        }) || route('app.search.units');
      }
    },
    { immediate: true },
  );

  return { findARoomButtonRoute };
}
